module.exports = __webpack_public_path__ + "static/media/Intruded tooth 9.0c4e6935.png";